/*
  Colour chips on product cards (snippets/card-colours.liquid).

  Hovering a chip (mouse only) previews that colour on the card: the main photo and the colour
  name switch, then switch back when the pointer leaves the chips. Tapping or clicking a chip is
  an ordinary link to that colour's product page.
*/

class CardColours extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    this.card = this.closest('product-card');
    this.image = this.card?.querySelector('.product-card__image--primary');
    this.name = this.card?.querySelector('[data-colour-name]');
    if (!this.image) return;

    this.original = {
      src: this.image.getAttribute('src'),
      srcset: this.image.getAttribute('srcset'),
      name: this.name?.textContent,
    };

    this.onEnter = this.onEnter.bind(this);
    this.onLeave = this.onLeave.bind(this);
    this.querySelectorAll('.card-colours__chip').forEach((chip) => chip.addEventListener('mouseenter', this.onEnter));
    this.addEventListener('mouseleave', this.onLeave);
  }

  onEnter(event) {
    const chip = event.currentTarget;
    if (chip.dataset.srcset) this.show(chip.dataset.src, chip.dataset.srcset);
    if (this.name && chip.dataset.name) this.name.textContent = chip.dataset.name;
  }

  onLeave() {
    this.show(this.original.src, this.original.srcset);
    if (this.name && this.original.name) this.name.textContent = this.original.name;
  }

  show(src, srcset) {
    if (srcset) this.image.setAttribute('srcset', srcset);
    if (src) this.image.setAttribute('src', src);
  }
}

if (!customElements.get('card-colours')) customElements.define('card-colours', CardColours);
